import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

export default function Navbar() {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-blue-600 dark:bg-gray-900 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="min-h-[64px] flex flex-col sm:flex-row items-center justify-between py-3 sm:py-2 gap-3">

          {/* Hospital Name */}
          <Link
            to="/"
            className="text-xl sm:text-2xl font-bold text-center sm:text-left"
          >
            City Multispecialty Hospital
          </Link>

          {/* Navigation Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">

            {/* Book Appointment */}
            <a
              href="/#appointment"
              className="px-3 py-2 text-sm sm:text-base rounded-md bg-white text-blue-600 hover:bg-gray-100 transition"
            >
              Book Appointment
            </a>

            {/* Leaderboard */}
            <Link
              to="/leaderboard"
              className="px-3 py-2 text-sm sm:text-base rounded-md bg-green-500 hover:bg-green-600 transition"
            >
              Leaderboard
            </Link>

            {/* Admin Login */}
            <Link
              to="/login"
              className="px-3 py-2 text-sm sm:text-base rounded-md bg-blue-800 hover:bg-blue-900 transition"
            >
              Admin Login
            </Link>

            {/* Dark Mode */}
            <button
              type="button"
              onClick={toggleDarkMode}
              className="px-3 py-2 text-sm sm:text-base rounded-md bg-gray-200 text-gray-900 hover:bg-gray-300 transition"
            >
              {darkMode ? "Light" : "Dark"}
            </button>

          </div>
        </div>
      </div>
    </nav>
  );
}
